import { Box, Image, Spacer, Text } from '@jfs/ui-new'
import { Linking } from 'react-native'
import { staticStrings } from '../../static/staticStrings'

export const EmailUs = () => {
  const contact = require('../../assets/svg/emailus.svg')

  return (
    <Box flexDirection={'row'} pl={16} zIndex={1000}>
      <Image width={36} height={36} source={contact} />
      <Spacer direction={'horizontal'} size={16} />
      <Box justify="center" zIndex={1000}>
        <Text title={staticStrings.emailus} fontSize={12} color={'BLACK_75'} fontFamily={'jiotype-medium'} />
        <Spacer size={4} />
        <Text
          title={staticStrings.supportEmail}
          fontSize={12}
          color={'BLUE'}
          fontFamily={'jiotype-medium'}
          textDecorationStyle={'solid'}
          textDecorationLine={'underline'}
          onPress={() => Linking.openURL(`mailto:${staticStrings.supportEmail}`)}
        />
      </Box>
    </Box>
  )
}
